import { Box, Stack } from "@mui/material";
import React from "react";

import "./statuscard.css";

const StatusCardDetailed = (props) => {
  return (
    <Box style={props.style} className="status-card w-100 m-auto">
      <Box className="status-card__info w-100">
        {props.data.map((v, i) => (
          <Stack
            key={i}
            direction={"row"}
            justifyContent={"space-between"}
            flexWrap={"wrap"}
          >
            <p> {v.name}: </p>
            <p size="lg" className="ms-3 fw-bold">
              {v.total}
            </p>
          </Stack>
        ))}
      </Box>
    </Box>
  );
};

export default StatusCardDetailed;
